import { Box, Table, TableBody, TableCell, TableRow, IconButton, LinearProgress } from "@mui/material";
import { StyledTableContainer, StyledTableHead, StyledTableRow, SortableColumn, SortIconButton } from "./styles";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { IComplaint } from "interfaces/IComplaints";
import { dateFormatWithHour } from "utils/dateFormat";

type SortField = 'created' | 'reason';

interface TableProps {
  complaints: IComplaint[];
  currentOrderBy?: SortField;
  currentOrderDirection?: 'asc' | 'desc';
  onSort: (orderBy: SortField, orderDirection: 'asc' | 'desc') => void;
  showLoading?: boolean;
}

const SortIcon = ({
  backendField,
  currentOrderBy,
  currentOrderDirection
}: {
  backendField: SortField;
  currentOrderBy?: SortField;
  currentOrderDirection?: 'asc' | 'desc';
}) => {
  if (currentOrderBy !== backendField) {
    return <ArrowUpwardIcon sx={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '16px' }} />;
  }
  return currentOrderDirection === 'asc' ?
    <ArrowUpwardIcon sx={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '16px' }} />
    : <ArrowDownwardIcon sx={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '16px' }} />;
};

export const ComplaintsTable = ({
  complaints,
  currentOrderBy,
  currentOrderDirection,
  onSort,
  showLoading
}: TableProps) => {

  const handleSort = (backendField: SortField) => {
    const newDirection = currentOrderBy === backendField && currentOrderDirection === 'asc' ? 'desc' : 'asc';
    onSort(backendField, newDirection);
  };

  return (
    <StyledTableContainer>
      <Table>
        <StyledTableHead>
          <TableRow>
            <TableCell sx={{ userSelect: 'none' }}>ID do pedido</TableCell>
            <TableCell>
              <SortableColumn onClick={() => handleSort('created')}>
                Data
                <SortIconButton size="small" className="sort-icon" active={currentOrderBy === 'created'}>
                  <SortIcon
                    backendField="created"
                    currentOrderBy={currentOrderBy}
                    currentOrderDirection={currentOrderDirection}
                  />
                </SortIconButton>
              </SortableColumn>
            </TableCell>
            <TableCell>
              <SortableColumn onClick={() => handleSort('reason')}>
                Motivo
                <SortIconButton size="small" className="sort-icon" active={currentOrderBy === 'reason'}>
                  <SortIcon
                    backendField="reason"
                    currentOrderBy={currentOrderBy}
                    currentOrderDirection={currentOrderDirection}
                  />
                </SortIconButton>
              </SortableColumn>
            </TableCell>
            <TableCell sx={{ userSelect: 'none' }}>Motorista</TableCell>
            <TableCell sx={{ userSelect: 'none' }}>Responsável</TableCell>
            <TableCell sx={{ userSelect: 'none' }}>Produto</TableCell>
            <TableCell sx={{ userSelect: 'none' }}>Observação</TableCell>
          </TableRow>

          {/* Barra de loading fixa junto com o cabeçalho */}
          {showLoading && (
            <TableRow>
              <TableCell colSpan={7} sx={{
                padding: 0,
                border: 'none',
                position: 'sticky',
                top: '48px',
                zIndex: 10,
                backgroundColor: 'white'
              }}>
                <LinearProgress />
              </TableCell>
            </TableRow>
          )}
        </StyledTableHead>

        <TableBody sx={{
          opacity: showLoading ? 0.6 : 1,
          transition: 'opacity 0.2s ease'
        }}>
          {complaints.map((complaint: IComplaint, index: number) => (
            <StyledTableRow key={index}>
              <TableCell>{complaint?.orderId}</TableCell>
              <TableCell>{dateFormatWithHour(complaint?.created)}</TableCell>
              <TableCell>{complaint?.reason}</TableCell>
              <TableCell>{complaint?.driverName}</TableCell>
              <TableCell>{complaint?.responsible}</TableCell>
              <TableCell>{complaint?.productName}</TableCell>
              <TableCell>{complaint?.observation || '-'}</TableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </StyledTableContainer>
  );
};
